import type { ButtonProps } from "@/types";
import { useApp } from "@h/useCtx";
import Button from "@ui/button";
import { Moon, Sun } from "lucide-react";
import { useTranslation } from "react-i18next";

interface ThemeToggleButtonProps {
  design?: ButtonProps["design"];
  className?: string;
  floatingPosition?: ButtonProps["floatingPosition"];
  inSheet?: boolean;
}

export default function ThemeToggleButton({
  floatingPosition = "bottom",
  design = "outline",
  inSheet = false,

  className,
}: ThemeToggleButtonProps) {
  const { theme, toggleTheme } = useApp();
  const { t } = useTranslation();
  const isDark = theme === "dark";
  const label = isDark ? t("light_mode") : t("dark_mode");
  return (
    <Button
      type="button"
      design={design}
      size={inSheet ? "default" : "icon"}
      onClick={toggleTheme}
      floatingLabel={inSheet ? undefined : label}
      label={inSheet ? label : undefined}
      floatingPosition={floatingPosition}
      icon={isDark ? Moon : Sun}
      className={className}
    />
  );
}
